import { animationPresetSchema, presetCatalogSchema } from '../schemas.js';
import { signatureOf } from '../signature.js';
import { z } from 'zod';
import baseSeed from './base-presets.json' with { type: 'json' };
/**
 * The read-only base preset seed shipped in `banner-core` (Epic 11 P01). These
 * are the deterministic baseline for the 10 predefined effect types (plus
 * ease-in-out fade variants) — the coder agent (Phase 02) only fires for effects
 * NOT already covered here or in the growing Postgres pool.
 *
 * The JSON is authored as a flat list of presets; the catalog is keyed by
 * deriving each preset's signature via {@link signatureOf}. Deriving (rather than
 * hand-keying the JSON) guarantees the seed keys always agree with what an
 * equivalent instruction's signature produces — the lookup-hit contract.
 */
const seedArraySchema = z.array(animationPresetSchema);
function buildSeedCatalog() {
    const presets = seedArraySchema.parse(baseSeed);
    const catalog = {};
    for (const preset of presets) {
        const signature = signatureOf(preset);
        // A duplicate signature in the seed is an authoring error (two presets that
        // normalize to the same effect) — fail loud rather than silently shadow.
        if (catalog[signature]) {
            throw new Error(`Duplicate base preset signature: ${signature}`);
        }
        catalog[signature] = preset;
    }
    return presetCatalogSchema.parse(catalog);
}
/** The validated, frozen base preset catalog keyed by normalized signature. */
export const BASE_PRESETS = Object.freeze(buildSeedCatalog());
/** Look up a base-seed preset by signature. Returns `undefined` on a seed miss. */
export function lookupSeedPreset(signature) {
    return BASE_PRESETS[signature];
}
export { MOTION_LIBRARY, findMotion, motionToPreset, isValidEasing, buildPresetAnimations, } from './library.js';
